import React from 'react';
import PropTypes from 'prop-types';
import FlexView from "../layoutComponents/FlexView";
import View from "../layoutComponents/View";
import Text from "../Text";
import IconButton from "../IconButton";
import { IconClose } from "../Icon";
import { styleguide, colors } from "../../styleguide";
import SnackbarTransition from "./SnackbarTransition";

var Snackbar = function Snackbar(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      subject = _ref.subject,
      description = _ref.description,
      icon = _ref.icon,
      showCloseBtn = _ref.showCloseBtn,
      _ref$onCloseBtn = _ref.onCloseBtn,
      onCloseBtn = _ref$onCloseBtn === void 0 ? true : _ref$onCloseBtn,
      onTransitionComplete = _ref.onTransitionComplete;
  var types = {
    info: {
      backgroundColor: colors.blue50,
      color: colors.blue600
    },
    error: {
      backgroundColor: colors.yellow900,
      color: colors.white100
    }
  };
  return /*#__PURE__*/React.createElement(View, {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(SnackbarTransition, {
    active: active,
    onTransitionComplete: onTransitionComplete
  }, /*#__PURE__*/React.createElement(FlexView, {
    style: {
      backgroundColor: types[type].backgroundColor
    }
  }, /*#__PURE__*/React.createElement(FlexView, null, icon && /*#__PURE__*/React.createElement(View, {
    style: {
      padding: 16,
      paddingRight: 0,
      backgroundColor: types[type].backgroundColor
    }
  }, icon), /*#__PURE__*/React.createElement(FlexView, {
    style: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      paddingTop: 16,
      paddingLeft: 16,
      paddingRight: 0
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      color: types[type].color,
      fontSize: '15px',
      fontFamily: styleguide.font.family.medium,
      lineHeight: 1.33
    }
  }, subject)), /*#__PURE__*/React.createElement(View, {
    style: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      paddingBottom: 16,
      paddingLeft: 16,
      paddingRight: 0
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      color: types[type].color,
      fontSize: 15,
      fontFamily: styleguide.font.family.regular,
      lineHeight: 1.33
    }
  }, description)))), showCloseBtn && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(IconClose, {
      width: 24,
      height: 24,
      color: types[type].color
    }),
    activeIcon: /*#__PURE__*/React.createElement(IconClose, {
      width: 24,
      height: 24,
      color: types[type].color
    }),
    onClick: onCloseBtn,
    style: {
      paddingLeft: 0,
      padding: 16,
      backgroundColor: types[type].backgroundColor
    }
  })))));
};

Snackbar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Theme of the snackbar
   */
  type: PropTypes.oneOf(['info', 'error']),

  /**
   * Show or hide the snackbar
   */
  active: PropTypes.bool,

  /**
   * The subject of the message (bolded)
   */
  subject: PropTypes.string,

  /**
   * The description to present to the user
   */
  description: PropTypes.node,

  /**
   * The icon you want to be displayed with the message
   */
  icon: PropTypes.node,

  /**
   * Enables and shows the close button `x` that closes the snackbar
   */
  showCloseBtn: PropTypes.bool,

  /**
   * Click event on the closeBtn
   */
  onCloseBtn: PropTypes.func,

  /**
   * Event when animation has completed
   */
  onTransitionComplete: PropTypes.func
} : {};
export default Snackbar;
//# sourceMappingURL=Snackbar.js.map